<template>
  <div>
    <template v-if="disabled">
      <span class="text-primary">{{ data }}</span>
    </template>
    <b-form-input
      v-else-if="option.isPlaceholder === 'false'"
      v-model="data"
      type="text"
      class="d-inline-block"
    />
    <b-form-input
      v-else
      v-model="data"
      :placeholder="option.placeholder? option.placeholder : $t('_components.placeholder.input')+label"
      type="text"
      class="d-inline-block"
    />
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  computed: {

  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
